import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Accordion from '../Accordion';
import Button from '../Button';
import Cta from '../Cta';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';

export default function TermsOfServicePage() {
    pageTitle('Terms of Service');
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const termsData = [
        {
            title: 'Introduction',
            content: `Welcome to ACE! These Terms of Service outline the rules and regulations for the use of our website and services. By accessing or using our services, you agree to comply with these terms. Please read them carefully.`,
        },
        {
            title: 'Services Provided',
            content: `ACE offers services including but not limited to website development, workflow automation, and AI-driven solutions. All services are provided as outlined in our agreements with clients.`,
        },
        {
            title: 'User Responsibilities',
            content: `As a user of our services, you agree to provide accurate information, adhere to applicable laws, and refrain from using our services for any unlawful or unauthorized purposes.`,
        },
        {
            title: 'Payment Terms',
            content: `All payments for our services must be made as per the agreed pricing plans. For yearly subscriptions, one month of service is provided free of charge. Failure to make timely payments may result in suspension of services.`,
        },
        {
            title: 'Intellectual Property',
            content: `All content, designs, and code created by ACE remain the intellectual property of ACE unless explicitly stated otherwise. Unauthorized reproduction or distribution of our intellectual property is prohibited.`,
        },
        {
            title: 'Termination',
            content: `We reserve the right to terminate services at our discretion if users violate these terms or engage in activities harmful to ACE or other users.`,
        },
        {
            title: 'Limitation of Liability',
            content: `ACE is not liable for any damages resulting from the use or inability to use our services, including but not limited to data loss, business interruptions, or unauthorized access to user data.`,
        },
        {
            title: 'Changes to Terms',
            content: `ACE reserves the right to update or modify these Terms of Service at any time. Users will be notified of any significant changes, and continued use of our services constitutes acceptance of the revised terms.`,
        },
        {
            title: 'Contact Information',
            content: `For any questions or concerns regarding these Terms of Service, please contact us via the details provided on our contact page.`,
        },
    ];

    return (
        <>
            <PageHeading
                title="Terms of Service"
                bgSrc="/images/about_hero_bg.jpeg"
                pageLinkText="Terms of Service"
            />
            <Spacing lg="150" md="80" />
            <Div className="container">
                <Div className="row">
                    <Div className="col-lg-10">
                        <Spacing lg="0" md="40" />
                        {termsData.map((term, index) => (
                            <Div key={index} id={term.title.replace(/\s+/g, '-').toLowerCase()}>
                                <h2 className="cs-terms_title">{term.title}</h2>
                                <p>{term.content}</p>
                                <Spacing lg="40" md="20" />
                            </Div>
                        ))}
                    </Div>
                </Div>
            </Div>
            <Spacing lg="150" md="80" />
            {/* Start CTA Section */}
            <Div className="container">
                <Cta
                    title="Let’s work <br />together to build something <i>amazing</i>"
                    btnText="Get in Touch"
                    btnLink="/contact"
                    bgSrc="/images/cta_bg.jpeg"
                />
            </Div>
            {/* End CTA Section */}
        </>
    );
}
